import BaseFactory from 'services/sports/default/base-factory';
import SimplexClassic from './simplex-classic';
import SimplexSinglegame from './simplex-singlegame';
import Const from 'constants';
import {Simplex} from 'services/sports/default/simplex';

const classesMap = {
    [Const.GAME_TYPE_CLASSIC]: SimplexClassic,
    [Const.GAME_TYPE_SINGLEGAME]: SimplexSinglegame,
};

class Factory extends BaseFactory {
    createObj(objectName, params) {
        const {sportConfig} = params;
        const gameType = sportConfig.getGameType();

        if (gameType in classesMap) {
            return new classesMap[gameType](params);
        }

        throw new Error(`Unknown gameType "${gameType}".`);
    }
}

export {Factory};
